export enum VideoConferenceBadgeDataHooks {
  VIDEO_CONFERENCE_BADGE = 'booking-details-video-conference-badge',
}
